exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-empty-data[data-v-f3ef0bf6] {\n  font-size: 1.15rem;\n  color: rgba(6, 38, 62, 0.64);\n  letter-spacing: 0.05rem;\n}\n", ""]);

// exports
